import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "@/components/ui/dialog";

interface SuccessDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const SuccessDialog = ({ open, onOpenChange }: SuccessDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md border-[#00DC82]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center mb-4">
            Thank You!
          </DialogTitle>
          <DialogDescription className="text-center space-y-4">
            <p className="text-lg">
              You've secured your spot on our exclusive waitlist of forward-thinking construction product manufacturers.
            </p>
            <p>
              We'll be in touch soon with more information about Sentiri and how we're addressing the challenges you've shared.
            </p>
            <p>
              Have questions? Contact us at info@sentiri.io
            </p>
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center mt-6">
          <DialogClose asChild>
            <Button className="bg-[#00DC82] text-white hover:bg-[#00DC82]/90">
              Close
            </Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};